import equipmentLogo from '../../assets/img/equipment.svg';
import transactionLogo from '../../assets/img/transaction.svg';
import usersLogo from '../../assets/img/people.svg';
import periodLogo from '../../assets/img/period.svg';
import bankLogo from '../../assets/img/bank.svg';
// import userLogo from '../../assets/img/user_white.png';
import homeLogo from '../../assets/img/home.svg';
import advertisingLogo from '../../assets/img/ad.svg';
import eventLogo from '../../assets/img/event_white.svg';
import glassesLogo from '../../assets/img/glass_white.svg';
import donationLogo from '../../assets/img/donation_white.svg';
import categoriesLogo from '../../assets/img/cup_categories_white.svg';

export interface ViewMapProps {
  label: string | undefined;
  link: string;
  icon: string;
}

const _zconfig: any = {
  menus: {
    downtime: true
  }
};

interface ViewMap {
  [key: string]: ViewMapProps;
}

const viewMap: ViewMap = {
  dashboard: {
    icon: homeLogo,
    label: 'DASHBOARD',
    link: '/dashboard'
  },
  equipment: {
    icon: equipmentLogo,
    label: 'GLOBAL_EQUIPMENT',
    link: '/equipment'
  },
  enterpriseTransactions: {
    icon: transactionLogo,
    label: 'MOVEMENTS',
    link: '/transactions'
  },
  users: {
    icon: usersLogo,
    label: 'GLOBAL_USERS',
    link: '/users'
  },
  enterpriseEquipmentPeriods: {
    icon: periodLogo,
    label: 'ENTERPRISE_EQUIP_PERIODS_SHORT',
    link: '/enterpriseEquiPeriods'
  },
  bankTransactions: {
    icon: bankLogo,
    label: 'BANK_TRANSACTIONS',
    link: '/bankTransactions'
  }
};

const viewVIMap: ViewMap = {
  advertising: {
    icon: advertisingLogo,
    label: 'ADVERTISEMENTS',
    link: '/vi/advertising'
  },
  events: {
    icon: eventLogo,
    label: 'EVENTS',
    link: '/vi/events'
  },
  glasses: {
    icon: glassesLogo,
    label: 'GLOBAL_GLASSES',
    link: '/vi/glasses'
  },
  processedGlasses: {
    icon: transactionLogo,
    label: 'MOVEMENTS',
    link: '/vi/movements'
  },
  donations: {
    icon: donationLogo,
    label: 'GLOBAL_DONATION',
    link: '/vi/donations'
  },
  glass_categories: {
    icon: categoriesLogo,
    label: 'CATEGORIES',
    link: '/vi/glasses/categories'
  }
  /* ,
  distributionList: {
    icon: advertisingLogo,
    label: 'ADVERTISEMENTS',
    link: '/vi/advertising'
  } */
};

/**
 * Verifies if logged user has permissions
 * Returns true or false
 * @param {*} appId Application ID
 * @param {*} mask permission mask
 * @param {*} userPermissions option
 */
const hasPermissions = function (appId: number, mask: number, userPermissions: any) {
  // if (!userPermissions) {
  //   userPermissions = JSON.parse(sessionStorage.userPermissions);
  // }
  if (!userPermissions) {
    return false;
  }
  for (let index = 0; index < userPermissions.length; index++) {
    let userPermission = userPermissions[index];
    if (appId === userPermission.appId) {
      return (userPermission.permissionCode & mask) !== 0;
    }
  }
};

let addUnique = function (menus: ViewMapProps[], menu: ViewMapProps) {
  if (!menus.includes(menu)) {
    menus.push(menu);
  }
};

/**
 * Constructs the menu list based on logged user permissions
 * @param {*} userPermissions
 */
export const buildUserMenus = function (userPermissions: any[]) {
  let menus: ViewMapProps[] = [];
  if (hasPermissions(1, 0x01 /* Edit users and permissions */, userPermissions)) {
    addUnique(menus, viewMap.users);
  }

  if (hasPermissions(1, 0x02 /* System Configurations */, userPermissions)) {
    addUnique(menus, viewVIMap.events);
    addUnique(menus, viewMap.equipment);
    addUnique(menus, viewVIMap.glasses);
    addUnique(menus, viewVIMap.glass_categories);
    addUnique(menus, viewVIMap.advertising);
    addUnique(menus, viewVIMap.donations);
    //addUnique(menus, viewMap.entities);
    //addUnique(menus, viewMap.branches);
    //addUnique(menus, viewMap.reasonsAndDeclarations);
    // if(_zconfig.menus?.eventDistributionList){
    //   addUnique(menus, viewMap.eventDistributionList);
    // }
    // if(_zconfig.menus?.withdrawalSetList){
    //   addUnique(menus, viewMap.withdrawalSetList);
    // }
    // if(_zconfig.menus?.biometricRecords){
    //   addUnique(menus, viewMap.biometricRecords);
    // }
    // if(_zconfig.menus?.nonbankuser){
    //   addUnique(menus, viewMap.nonbankuser);
    // }
    // if(_zconfig.menus?.downtime){
    //   addUnique(menus, viewMap.downtime);
    // }
  }

  if (hasPermissions(1, 0x04 /* Equipment Remote Operations */, userPermissions)) {
    addUnique(menus, viewMap.equipment);
  }

  if (hasPermissions(1, 0x20 /* Equipment Technician */, userPermissions)) {
    addUnique(menus, viewMap.equipment);
  }

  if (hasPermissions(2, 0x01 /* Financial data */, userPermissions)) {
    addUnique(menus, viewMap.equipment);
    //addUnique(menus, viewMap.userSummary);
    //addUnique(menus, viewMap.enterpriseTransactions);
    // addUnique(menus, viewMap.enterpriseShifts);
    //addUnique(menus, viewMap.enterpriseEquipmentPeriods);
    //addUnique(menus, viewMap.bankTransactions);
    // addUnique(menus, viewMap.bankEquipmentPeriods);
    // addUnique(menus, viewMap.dashboard);

    addUnique(menus, viewVIMap.processedGlasses);
  }

  if (hasPermissions(2, 0x02 /* CIT */, userPermissions)) {
    //addUnique(menus, viewMap.bankEquipmentPeriods);
    //addUnique(menus, viewMap.enterpriseEquipmentPeriods);
    addUnique(menus, viewMap.equipment);
  }

  if (hasPermissions(2, 0x04 /* Equipment Remote Financial Operations */, userPermissions)) {
    addUnique(menus, viewMap.equipment);
  }

  if (hasPermissions(2, 0x08 /* Operator */, userPermissions)) {
    //addUnique(menus, viewMap.enterpriseTransactions);
    //addUnique(menus, viewMap.enterpriseShifts);
  }

  // if (hasPermissions(2, 0x10 /* APM */ , userPermissions)) {
  //   addUnique(menus, viewMap.apmTransactions);
  //   addUnique(menus, viewMap.apmPeriods);
  //   addUnique(menus, viewMap.apmPoss);
  //   addUnique(menus, viewMap.apmReports);
  // }

  // if (hasPermissions(4, 0x08 /* Helpdesk */ , userPermissions)) {
  //   addUnique(menus, viewMap.msEquipmentList);
  //   addUnique(menus, viewMap.msTicketList);
  //   addUnique(menus, viewMap.msDeviceList);
  //   addUnique(menus, viewMap.msEvents);
  //   addUnique(menus, viewMap.msTlogs);
  //   addUnique(menus, viewMap.msAuditLog);
  //   addUnique(menus, viewMap.msSyncCommands);
  //   addUnique(menus, viewMap.msCounter);
  // }

  // if (hasPermissions(4, 0x02 /* Client management */ , userPermissions)) {
  //   addUnique(menus, viewMap.msEquipmentList);
  //   addUnique(menus, viewMap.msEntities);
  //   // addUnique(menus, viewMap.msPosSibs);
  // }

  // if (hasPermissions(4, 0x01 /* Agreement management */ , userPermissions)) {
  //   addUnique(menus, viewMap.msAgreement);
  // }

  // if (hasPermissions(4, 0x20 /* Event & Counter management */ , userPermissions)) {
  //   addUnique(menus, viewMap.msCounterDefs);
  //   addUnique(menus, viewMap.msEventManagement);
  // }

  // if (hasPermissions(5, 0x02 /* Manage Productions */ , userPermissions)) {
  //   addUnique(menus, viewMap.msWarehouse);
  //   addUnique(menus, viewMap.billOfMaterials);
  // }

  // if (hasPermissions(5, 0x04 /* Product Reception */ , userPermissions)) {
  //   addUnique(menus, viewMap.receptionProductions);
  //   addUnique(menus, viewMap.documents); //Limited access
  //   addUnique(menus, viewMap.msWarehouse);
  // }

  // if (hasPermissions(5, 0x01 /* Manage Products */ , userPermissions)) {
  //   addUnique(menus, viewMap.productManagement);
  // }

  // if (hasPermissions(100, 0x02 /* Stocks */ , userPermissions)) {
  //   addUnique(menus, viewMap.stocks);
  //   addUnique(menus, viewMap.stockinout);
  // }

  // if (hasPermissions(100, 0x04 /* Documents */ , userPermissions)) {
  //   addUnique(menus, viewMap.documents);
  // }

  // addUnique(menus, viewMap.userProfile);

  return menus;
};
